module.exports = __webpack_public_path__ + "static/media/icon-complete.aab616c0.svg";